module.exports = __webpack_public_path__ + "img/16.ff9d207b.jpg";